/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Modal, Form, Input, Switch } from 'antd';
import { modalMethod } from 'components';
import { useSaveAssigneeManager, useUpdateAssigneeManager, TAssigneeManager } from 'hooks';
import checkGreenIcon from 'images/other/ic-check-green@3x.png';

import { ModalContent } from '../styles';

interface AccountManagerModalProps {
  open: boolean;
  assigneeManager?: TAssigneeManager;
  partnerContractIdx?: number;
  isReceivedLimits?: boolean;
  onCancel?: (event?: any, values?: TAssigneeManager, isRefresh?: boolean) => void;
}

const AccountManagerModal = ({
  open,
  partnerContractIdx,
  assigneeManager,
  isReceivedLimits,
  onCancel
}: AccountManagerModalProps) => {
  const [form] = Form.useForm<TAssigneeManager>();
  const validate = Form.useWatch([], form);
  const baseText = assigneeManager ? '수정' : '등록';

  const [fieldErrors, setFieldErrors] = React.useState<Record<string, boolean>>({});

  const { mutateAsync: saveAssigneeManager } = useSaveAssigneeManager();
  const { mutateAsync: updateAssigneeManager } = useUpdateAssigneeManager();

  React.useEffect(() => {
    // form.validateFields();
    if (open) {
      form.setFieldsValue({ isReceivedTaxInvoice: false, ...assigneeManager });
    } else {
      form.resetFields();
    }
  }, [form, open, assigneeManager]);

  const handleSubmit = async (params: TAssigneeManager) => {
    if (!partnerContractIdx) return;

    const confirmResult = await modalMethod.confirm(`정산 담당자 정보를 ${baseText}하시겠습니까?`, { cancelText: '닫기' });
    if (!confirmResult) return;
    if (assigneeManager) {
      await updateAssigneeManager({ partnerContractIdx, params, assigneeManagerIdx: assigneeManager?.managerIdx });
    } else {
      await saveAssigneeManager({ partnerContractIdx, params });
    }

    modalMethod.info(`정산 담당자 정보 ${baseText}이 완료되었습니다.`);
    onCancel(null, null, true);
  };

  const handleFieldsChange = () => {
    const errors = form.getFieldsError();
    const { managerName, managerEmail, managerPhoneNumber } = validate || {};
    setFieldErrors({
      isValidManagerName: !!managerName && !errors.find(({ name }) => name[0] === 'managerName').errors.length,
      isValidManagerEmail: !!managerEmail && !errors.find(({ name }) => name[0] === 'managerEmail').errors.length,
      isValidManagerPhone: !!managerPhoneNumber && !errors.find(({ name }) => name[0] === 'managerPhoneNumber').errors.length
    });
  };

  return (
    <Modal
      title={`담당자 ${baseText}`}
      open={open}
      onCancel={onCancel}
      okText={`${baseText}하기`}
      okButtonProps={{ form: 'managerInfoForm', htmlType: 'submit', style: { borderRadius: '4px' } }}
      cancelText="닫기"
      cancelButtonProps={{ style: { borderRadius: '4px' } }}
    >
      <ModalContent>
        <Form form={form} name="managerInfoForm" layout="vertical" onFinish={handleSubmit} onFieldsChange={handleFieldsChange}>
          <Form.Item label="담당자명" name="managerName" rules={[{ required: true, message: '담당자명을 입력해 주세요.' }]}>
            <Input suffix={fieldErrors?.isValidManagerName ? <img src={checkGreenIcon} alt="" /> : <div />} />
          </Form.Item>
          <Form.Item
            label="이메일"
            name="managerEmail"
            rules={[
              { required: true, message: '이메일을 입력해 주세요.' },
              { type: 'email', message: '올바른 이메일을 입력해주세요.' }
            ]}
          >
            <Input suffix={fieldErrors?.isValidManagerEmail ? <img src={checkGreenIcon} alt="" /> : <div />} />
          </Form.Item>
          <Form.Item label="전화번호" name="managerPhoneNumber">
            <Input suffix={fieldErrors?.isValidManagerPhone ? <img src={checkGreenIcon} alt="" /> : <div />} />
          </Form.Item>
          <Form.Item
            label="세금계산서 이메일 수신여부"
            name="isReceivedTaxInvoice"
            className="horizontal-item"
            valuePropName="checked"
          >
            <Switch checkedChildren="Y" disabled={!assigneeManager?.isReceivedTaxInvoice && isReceivedLimits} />
          </Form.Item>
        </Form>
        <ul>
          <li>이메일 정보는 중복 등록이 불가합니다.</li>
          <li>세금계산서 수신은 담당자 중 1명만 가능합니다.</li>
          <li>담당자 정보를 수정 할 시, 해당 정보는 익월 정산서 부터 적용됩니다.</li>
          <li>세금계산서 담당자를 당 월 수정이 필요한 경우는 하단의 1:1 문의로 요청주세요.</li>
        </ul>
      </ModalContent>
    </Modal>
  );
};

export default AccountManagerModal;
